export default __webpack_public_path__ + "static/media/no_friends.313cc5fb.svg";